import { DDL } from "../ddl";
import { CampaignDetail } from "./campaign-detail";


export class Campaign {
    public AuditRequestID: number = -1;
    public RequestGUID: string = "";
    public SelectedAuditID: number = -1;
    public PublicAuditName: string = "";
    public RequestName: string = "";
    public SendDate: Date = new Date();
    public ExpiryDate: Date = new Date();
    public Recipients: CampaignDetail[] = [];
    public Anonymous: boolean = false;
    public ManuallyClosed: boolean = false;
    public OriginalAuditName: string = "";
    public Creator: string = "";
    public TotalSent: number = -1;
    public TotalAccessed: number = -1;
    public TotalSubmitted: number = -1;
    public TotalFailed: number = -1;
    public Active: boolean = true;
    public RecipientsLoaded: boolean = false;
    public Location: DDL = new DDL();
    public TotalScore: number = 0;
    public TotalMaxScore: number = 0;
    public CreateLink: boolean = false;
    public Link: string = '';
    //FrontEndUseOnly
    public PendingStop: boolean = false;
    public ViewLink: boolean = false;
    constructor(values: Object = {}) {
        Object.assign(this, values);
        if (values.hasOwnProperty('Recipients')) {
            this.Recipients = [];
            ((values as Campaign)['Recipients'] as CampaignDetail[]).forEach(element => {
                this.Recipients.push(new CampaignDetail(element));
            });
        }
    }
}

